import { flow, getRoot, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { RootStore } from './RootStore';
import { Datalist } from 'glamorous';
import { AnalysisScore } from './models/AnalysisScore';

// export const SearchCriteria = types.model({
//   secretariatId: types.maybeNull(types.number),
//   isActive: types.maybeNull(types.boolean),
// });

// export const PharmacyViews = {
//   SIMPLE: 'SIMPLE',
//   DETAILED: 'DETAILED',
// };

export const ScoreStore = types
  .compose(
    getBaseStore<Instance<typeof AnalysisScore>, Instance<typeof AnalysisScore>>(AnalysisScore, 'scoreId', 'score'),
    types.model('ScoreStore', {}),
  )
  .views((self) => ({
    getScoreList() {
      return Datalist;
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: Instance<typeof RootStore> = getRoot(self);
    const apiFetcher = env.api;

    const getScores = flow(function*(data: any) {
      const result = yield env.api.get('Planning/getScores/' + data.count, data);
      if (result != null) {
        self.putInStore(result);
      }
    });

    // const updatePharmacyInStore = (pharmacy: Instance<typeof Pharmacy>) => {
    //   const pharmacyModel = Pharmacy.create(pharmacy);
    //   self.datas.put(pharmacyModel);
    //   return pharmacyModel;
    // };

    // const savePharmacy = flow(function*(pharmacy: Instance<typeof Pharmacy>) {
    //   const res = yield self.saveElement(pharmacy);
    //   if (pharmacy.pharmacyId !== res.pharmacyId) {
    //     root.ApplicationStore.navigate(`${Page.Pharmacies}/${res.pharmacyId}`);
    //   }
    // });

    // const search = flow(function*(criteria: Instance<typeof SearchCriteria>) {
    //   const result = yield apiFetcher.get('pharmacy', {
    //     params: {
    //       ...criteria,
    //       view: PharmacyViews.SIMPLE,
    //     },
    //   });
    //   const resultPharmacy: Array<Instance<typeof Pharmacy>> = [];
    //   result.forEach((node) => {
    //     const createdPharmacy = updatePharmacyInStore(node);
    //     resultPharmacy.push(createdPharmacy);
    //   });
    //   return resultPharmacy;
    // });

    // const loadNeighbors = flow(function*(pharmacyId: number) {
    //   const result = yield apiFetcher.get(`pharmacy/${pharmacyId}/neighbors`, {
    //     params: {
    //       view: PharmacyViews.SIMPLE,
    //     },
    //   });
    //   self.setDatasFromArray(result);
    // });

    // const searchForDutyAssignment = flow(function*(criteria: DutyAssignmentSearchCriteria) {
    //   const result = yield env.api.get('dutyAssignment/pharmacy', {
    //     params: {
    //       ...criteria,
    //       view: PharmacyViews.SIMPLE,
    //     },
    //   });

    //   self.putInStore(result!);
    //   const resultIds = result!.map((r) => r.pharmacyId);
    //   return self.dataList.filter((d) => resultIds.indexOf(d.pharmacyId) >= 0);
    // });

    return {
      // savePharmacy,
      // search,
      // loadNeighbors,
      // searchForDutyAssignment,
      getScores,
    };
  });

export type ScoreStoreType = typeof ScoreStore.Type;
